/*
 * Types.
 */

import {OnlineTeammate} from '../../src/models/push/onlineTeammateModel';
import {SharedPushDispatchProps} from './pushCommons';
import {PushCoordinator} from './pushCoordinator';

export type PresenceSubscriptions = ReturnType<typeof makePresenceSubscriptions>;

export function makePresenceSubscriptions(props: SharedPushDispatchProps, coordinator: PushCoordinator) {
  return [
    {
      name: 'initialPresence',
      handler: (teammates: ReadonlyArray<OnlineTeammate>) => {
        coordinator.enqueueTask(() => () => {
          props.setOnlineTeammates(teammates);
        });
      },
    },
    {
      name: 'teammateOnline',
      handler: (teammate: OnlineTeammate) => {
        coordinator.enqueueTask(() => () => {
          props.updateIsTeammateOnline(teammate, true);
        });
      },
    },
    {
      name: 'teammateOffline',
      handler: (teammate: OnlineTeammate) => {
        coordinator.enqueueTask(() => () => {
          props.updateIsTeammateOnline(teammate, false);
        });
      },
    },
  ];
}
